module.exports = __webpack_public_path__ + "static/img/google-play.10eff31.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/google-play.png
// module id = 339
// module chunks = 6